/*eslint-disable*/
import React from 'react'
import { Link } from 'react-router-dom'

const ServicesCard = ({ business }) => {
  return (
    <article className='w-full space-y-4 text-left gap-6 relative rounded-xl border border-slate-300 border-opacity-25 p-4 lg:p-6 cursor-pointer hover:bg-oya-ghana-light-gray hover:scale-105 transition duration-500'>
      <div className='flex items-start justify-start gap-1'>
        <img src={`/assets/images/services-icons/${business.icon}`} alt='' />
        <h5 className='text-oya-ghana-header-h5 font-bold'>{business.title}</h5>
      </div>
      <p className='text-oya-ghana-header-h7 pb-4'>{business.desc}</p>
      <Link
        to={`/service/${business.slug}`}
        className='text-oya-ghana-green text-oya-ghana-header-h7 font-medium'
      >
        LEARN MORE
      </Link>
    </article>
  )
}

export default ServicesCard
